import { render, staticRenderFns } from "./CommonComponent.vue?vue&type=template&id=7dc1c774&scoped=true"
import script from "./CommonComponent.vue?vue&type=script&lang=js"
export * from "./CommonComponent.vue?vue&type=script&lang=js"
import style0 from "./CommonComponent.vue?vue&type=style&index=0&id=7dc1c774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc1c774",
  null
  
)

export default component.exports